import Select from 'ol-ext/control/Select';
import { itineraryEntriesData } from './source';
import { travelsData } from './source';


export const selectPeriod = new Select({
    source: itineraryEntriesData,
    className: 'selectPeriod',
})

export const selectPeriodTravels = new Select({
    className: 'selectPeriodTravels',
    source: travelsData,
});



export function createConditions() {
    let stagesChecked = { 1: $('#stage1').is(':checked'), 2: $('#stage2').is(':checked'), 3: $('#stage3').is(':checked') };
    let travelsChecked = {
        1: { 4: $('#travel4').is(':checked'), 5: $('#travel5').is(':checked') },
        2: { 6: $('#travel6').is(':checked'), 7: $('#travel7').is(':checked'), 8: $('#travel8').is(':checked') },
        3: { 9: $('#travel9').is(':checked') }
    };
    let staysChecked = {
        1: { 110: $('#stay10_stage1').is(':checked'), 111: $('#stay11_stage1').is(':checked'), 112: $('#stay12_stage1').is(':checked'), 100: $('#stay1_other').is(':checked') },
        2: { 211: $('#stay11_stage2').is(':checked'), 200: $('#stay2_other').is(':checked') },
        3: { 310: $('#stay10_stage3').is(':checked'), 311: $('#stay11_stage3').is(':checked'), 300: $('#stay3_other').is(':checked') }
    };

    let conditions = [];

    for (const [key, value] of Object.entries(stagesChecked)) {
        if (!value) {
            continue;
        }

        conditions.push({
            attr: 'Travels_stage',
            op: '=',
            val: key
        });
    }

    for (const [key, value] of Object.entries(stagesChecked)) {
        for (const [travelKey, travelValue] of Object.entries(travelsChecked[key])) {
            if (!travelValue) {
                continue;
            }

            conditions.push({
                attr: 'Travels_travel',
                op: '=',
                val: travelKey
            });
        }
    }

    for (const [key, value] of Object.entries(stagesChecked)) {
        for (const [staysKey, staysValue] of Object.entries(staysChecked[key])) {
            if (!staysValue) {
                continue;
            }

            conditions.push({
                attr: 'Travels_stay',
                op: '=',
                val: staysKey
            });
        }
    }

    if (!stagesChecked[1] && !stagesChecked[2] && !stagesChecked[3]) {
        conditions.push({
            attr: 'Travels_stage',
            op: '=',
            val: '-999'
        });
    }

    return conditions;
}
